import { createContext } from 'react';
import http from 'hub-http/clients/apiClient';

/**
 * Context to allow consumers to provide their own HTTP client to components here.
 * @example
 * import { HttpClientContext } from 'ui-coaching-tips/api/HttpClientContext';
 *
 * <HttpClientContext.Provider value={http}>
 *   { content }
 * </HttpClientContext.Provider>
 *
 * Consumption:
 * import { useHttpClient } from 'ui-coaching-tips/hooks/useHttpClient';
 *
 * const http = useHttpClient();
 * http now uses the provided client, or by default, `apiClient` from hub-http
 */
export const HttpClientContext = /*#__PURE__*/createContext(http);